import { AppState } from '@/app/app-reducer';
import * as dataSelectors from '@/data/data-selectors';
import { LoadingPlaceholder } from '@/widgets/components/data-loading-placeholder';
import React from 'react';
import { connect } from 'react-redux';

interface WithDataLoadingProps {
  propertyList?: Record<string, unknown>[];
  stats?: unknown;
  [key: string]: unknown;
}

/**
 * Higher-order component that handles data loading for routes
 * Shows loading placeholders until propertyList and stats are loaded
 */
export const withDataLoading = (
  WrappedComponent: React.ComponentType,
  config: {
    withStats?: boolean;
    withPropertyList?: boolean;
  } = {}
) => {
  class WithDataLoading extends React.Component<WithDataLoadingProps> {
    render() {
      const { propertyList, stats, ...restProps } = this.props;

      const { withStats = true, withPropertyList = true } = config;

      if (withPropertyList && !propertyList) {
        return <LoadingPlaceholder />;
      }

      if (withStats && !stats) {
        return <LoadingPlaceholder />;
      }

      return <WrappedComponent {...restProps} />;
    }
  }

  const mapStateToProps = (state: AppState) => ({
    propertyList: dataSelectors.propertyList(state),
    stats: dataSelectors.stats(state),
  });

  return connect(mapStateToProps)(WithDataLoading);
};
